// removed by extract-text-webpack-plugin
module.exports = {"scroll-box":"faq__scroll-box__2vA9Q","questions":"faq__questions__1Q-W3","questions-mobile":"faq__questions-mobile__2ah9r","header":"faq__header__1qLM2","answer-items":"faq__answer-items__26h3t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FAQ/faq.scss
// module id = 96
// module chunks = 0